import { render, staticRenderFns } from "./AdminProviders.vue?vue&type=template&id=a5cee97a"
import script from "./AdminProviders.vue?vue&type=script&lang=js"
export * from "./AdminProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports